import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/tubelight-navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/cta-action-button.tsx");
